// cart page    // ship on ice
$(document).ready(function(){
  $("#shipOnIce").click(function(){      
    if($(this).prop("checked") == true){
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: {id:35881987604646},
        success: function(){
          location.reload();
          location.href="/cart";
        }
      });
    }
    else if($(this).prop("checked") == false){
      $.ajax({
        type: 'POST', 
        url: '/cart/change.js',
        dataType: 'json', 
        data: {id:35881987604646,quantity: 0},
        success: function(){
          location.reload();
          location.href="/cart";
        }
      });
    }
});   
// signature product
$("#sDy").click(function(){
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: {id:35881967648934},
      success: function(){
        location.reload();
        location.href="/cart";
      }
    });
  });
$("#sDn").click(function(){
    $.ajax({
      type: 'POST', 
      url: '/cart/change.js',
      dataType: 'json', 
      data: {id:35881967648934,quantity: 0},
      success: function(){
        location.reload();
        location.href="/cart";
      }
    });
});
$('.cart__subtotal-price').on('DOMSubtreeModified',function(){
  var ab =	$('.cart__subtotal-price').text();
  var res = ab.split("$");
  var abs = parseInt(res[1]);
  if(abs >= 100){$('.ship2H').show();}else{$('.ship2H').hide();}
  if(abs >= 200){$('.ship3H').show();}else{$('.ship3H').hide();}
  if(abs >= 300){$('.ship4H').show();}else{$('.ship4H').hide();}
  if(abs >= 400){$('.ship5H').show();}else{$('.ship5H').hide();}
  if(abs >= 500){$('.ship6H').show();}else{$('.ship6H').hide();}
  if(abs >= 600){$('.ship7H').show();}else{$('.ship7H').hide();}
});

// shipping insurance   //   declare the product id in array ,
  var ab =  $('input[name=shippingInsurance]:checked','.customShipIns').val();
  var shipInsval = ["35964165947558","35966900895910","35968494895270","35968515997862","35968533823654","35968549912742","35968564265126"];
  $(".customShipIns").on('click', function(){
    var a =  $('input[name=shippingInsurance]:checked','.customShipIns').val(); 
    if(a >= 0 ){
      $.ajax({
        type: 'POST', 
        url: '/cart/change.js',
        dataType: 'json', 
        data: {id:shipInsval[ab],quantity: 0},
        success: function(){
          location.reload();
          location.href="/cart";
        }
      });
        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: {id:shipInsval[a]},
                success: function(){
                location.reload();
                location.href="/cart";
                }
            });}
    });
    });
// brand colleciton landing page
$(document).ready(function(){
$(".brands__description").hide();
  $(".brands__learn-more").on('click',function(){
  $(".brands__description").show();
  $(".brands__learn-more").hide();
});
$(".brands__close").on('click',function(){
  $(".brands__description").hide();
  $(".brands__learn-more").show();
});
});


// filter hide in mobile begin

// filter hide in mobile show



// search field in Mobile.
// $("#mblSearch").click(function(){
//   $('.js-drawer-close').trigger( "click" );
// }); 

document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.site-header');
  if (header) {
    var height = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }
});